/* eslint-disable */
import React, { createContext, useContext, useState, useEffect } from 'react';
import { DEFAULT_MESSAGE_DISPLAY_DURATION } from 'common/config';

export interface IMessageContext {
  showErrorMessage: (value: string, duration?: number) => void;
  showSuccessMessage: (message?: string, duration?: number) => void;
}

const MessageContext = createContext<IMessageContext>({
  showErrorMessage: () => {},
  showSuccessMessage: () => {},
});

export const useMessageContext = () => useContext(MessageContext);

export const MessageProvider = ({ children }: { children: React.ReactNode }) => {
  const [show, setShow] = useState<boolean>(false);
  const [type, setType] = useState<'error' | 'success' | null>('error');
  const [message, setMessage] = useState<string>('');
  const [duration, setDuration] = useState<number>(DEFAULT_MESSAGE_DISPLAY_DURATION);
  const [showTime, setShowTime] = useState<number | null>(null);

  const destroy = () => {
    setShow(false);
    setType(null);
    setMessage('');
    setDuration(DEFAULT_MESSAGE_DISPLAY_DURATION);
  };

  const showErrorMessage = (message: string, duration = DEFAULT_MESSAGE_DISPLAY_DURATION) => {
    setType('error');
    setMessage(message);
    setDuration(duration);
    setShowTime(Date.now());
    setShow(true);
  };

  const showSuccessMessage = (message = 'Success', duration = DEFAULT_MESSAGE_DISPLAY_DURATION) => {
    setType('success');
    setMessage(message);
    setDuration(duration);
    setShowTime(Date.now());
    setShow(true);
  };

  useEffect(() => {
    if (show) {
      setShowTime(Date.now());
    }
  }, [show]);

  // @ts-ignore
  useEffect(() => {
    if (showTime) {
      const timer = setInterval(() => {
        const elapsedTime = Date.now() - showTime;
        if (elapsedTime >= duration) {
          destroy();
          setShowTime(null);
          clearInterval(timer);
        }
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [showTime, duration]);

  return (
    <MessageContext.Provider
      value={{
        showErrorMessage,
        showSuccessMessage,
      }}
    >
      {children}

      <div className={`message ${show ? 'active' : ''}`}>
        <div className={`${type}`} />

        <span>{message}</span>
      </div>
    </MessageContext.Provider>
  );
};
